export * from './CollectionWidgetFooter'
